import { ILoopRange, ISong, ISongNote } from "../services/Entities";

export class Song { 

    protected _song: ISong;

    constructor(song: ISong) {
        this._song = song;
        this.speed = 1;
        this.key = 0;
    }

    *notes() {
        for (let i = 0; i < this._song.notes.length; i++)
            yield this.note(i);
    }

    note(index: number) {
        const note = this._song.notes[index];
  
        return {
            duration: note.duration / (this.speed ?? 1),
            time: note.time / (this.speed ?? 1),
            velocity: note.velocity,
            note: Math.max(0, Math.min(note.note + (this.key ?? 0) * 12, 12 * 8))
        } as ISongNote;
    }

    get length() {
        return this._song.notes.length;
    }
    get bpm() {
        return this._song.bpm;
    }
    get tempo() {
        return this._song.tempo;
    }
    get name() {
        return this._song.name;
    }

    get preSynthTrack() {
        return this._song.preSynthTrack;
    }

    loopRange: ILoopRange;

    speed: number;
    key: number;
}